import { post } from '../../utils/http';

export const submitRewriteRequest = ({ accountId, threadId, originalText, userPrompt }) => {
  return post(`/accounts/${accountId}/ai-agent/feed-agent/${threadId}/rewrite`, {
    userPrompt: userPrompt.trim(),
    originalText: (originalText || '').trim()
  });
};
